import menuToggle from './navbar'

import {
	fileInputContainers,
	fileInputs,
	inputFields,
	removeItemIcons,
} from './inputFields'
import teamCardSlider from './teamCardSlider'
import partnerInfoSlider from './partnersInfo'
import testimonySlider from './testimonialSlider'
import expandableList from './expandableList'
import modal from './modal'
import trustpilot from './trustpilot'
import table from './table'
import productDetails from './productDetails'
import initGrabScroll from './initGrabScroll'
export { menuToggle }

const successModal = document.querySelector('.success-modal')

window.addEventListener('DOMContentLoaded', (event) => {
	if (event.target.URL) {
		const message = event.target.URL.split('#')[1]
		if (message === 'success') successModal.style.display = 'block'
	}
})
